"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScreenSize = void 0;
const react_native_1 = require("react-native");
const helpers_1 = require("./helpers");
function useScreenSize() {
    const { width } = react_native_1.useWindowDimensions();
    const size = helpers_1.getScreenSizeFromWidth(width);
    return size;
}
exports.useScreenSize = useScreenSize;
